import { create } from 'zustand';

// Drives the mobile-only TopBar "Preview" button and the global full-screen widget dialog.
interface MobilePreviewStore {
  open: boolean;
  openPreview: () => void;
  closePreview: () => void;
}

export const useMobilePreviewStore = create<MobilePreviewStore>((set) => ({
  open: false,
  openPreview: () => set({ open: true }),
  closePreview: () => set({ open: false }),
}));
